import {connect} from 'react-redux';
import tabActions from '../../redux/actions/tab.actions';
import Tabs from './LEGACY_Tabs';

const mapStateToProps = state => ({
    activeTab: state.getIn(['tab', 'active'])
});

const mapDispatchToProps = dispatch => ({
    setActiveTab: tabIndex => dispatch(tabActions.setActiveTab(tabIndex))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Tabs);
